export default __webpack_public_path__ + "static/media/vector-db.cb2db621.svg";